import lodash from 'lodash';

/**
 * Use this directive sparingly. It will cause a reflow when the element in question is resized.
 */
export const onSizeChangedDirective = function ($window, $timeout) {
    'ngInject';
    return {
        restrict: 'A',
        scope: {
            onSizeChanged: '&',
        },
        link: function (scope, $element) {
            let element = $element[0];

            function emitOnSizeChanged() {
                // unwrap the callback
                let expression = scope.onSizeChanged();
                // and call it
                expression(element.offsetWidth, element.offsetHeight);
            }

            function calculateSize() {
                return element.offsetWidth + ' ' + element.offsetHeight;
            }

            // 3 seconds seems like a good throttling value
            scope.$watch(lodash.throttle(calculateSize, 3000), () => {
                emitOnSizeChanged();
            });

            // Trigger an initial change
            // Hacky: Call it using timeout so that other directives using this directive
            // get the initial on size event.
            $timeout(function () {
                emitOnSizeChanged();
            }, 0);
        },
    };
};
